import { CellDecorator } from '../Enum/TableDecorator';
import { Cell, HeaderCell, InterestTableDTO, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { ProductProperty, PropertiesPerLabel } from '../Interface/Response/Interest/PropertiesPerLabel';
import { Label } from '../Interface/Response/Interest/Label';
import { AcceptationGuideData } from '../Interface/Response/Interest/AcceptationGuideData';

import { findForLabel } from '../Helpers/Filter/AcceptationGuideHelper';
import { getLabel } from '../Helpers/LabelHelper';

const getProperty = (label: PropertiesPerLabel, name: string): ProductProperty | undefined =>
    label.properties.find(property => property.name === name);

const getUniquePropertyNames = (properties: PropertiesPerLabel[]): string[] => {
    const propertyNames: string[] = [];
    properties.forEach(propertyPerLabel => {
        propertyPerLabel.properties.forEach(property => {
            propertyNames.push(property.name);
        });
    });

    return propertyNames.filter((value, index, self) => self.indexOf(value) === index);
};

const getScopeOfProperty = (labels: PropertiesPerLabel[], uniquePropertyName: string): string => {
    let categoryName = '';
    labels.forEach(label => {
        label.properties.forEach(({ name, category }) => {
            if (name === uniquePropertyName) {
                categoryName = category;
            }
        });
    });

    return categoryName;
};

const reduceTablePropertiesPerLabelData = (
    properties: PropertiesPerLabel[],
    allLabels: Label[],
    acceptationGuideData: AcceptationGuideData[],
): InterestTableDTO => {
    const headers: HeaderCell[] = properties.map(property => {
        const currentLabel = getLabel(allLabels, property.finDataCode);
        const dataForLabel = findForLabel(acceptationGuideData, currentLabel);

        return {
            appendix: {
                value: {
                    label: currentLabel.label,
                    acceptationGuideData: dataForLabel
                },
                decorator: CellDecorator.AcceptationGuide,
            },
            decorator: CellDecorator.CompanyIcon,
            prop: currentLabel.findataCode,
            value: currentLabel.findataCode,
        };
    });

    headers.unshift({
        value: 'Voorwaarden',
        prop: 'voorwaarden',
        alwaysUseInPdf: true,
    });

    const uniquePropertyNames = getUniquePropertyNames(properties);

    const data: Row[] = [];

    for (const uniquePropertyName of uniquePropertyNames) {
        const cells = properties.reduce((acc: Cell[], curValue) => {
            const property = getProperty(curValue, uniquePropertyName);
            const cell = { value: property?.attributes, decorator: CellDecorator.ProductProperty };
            if (cell.value) {
                cell.value.label = getLabel(allLabels, property?.attributes.finDataCode);
                cell.value.property = property;
            }
            return [...acc, cell];
        }, []);

        cells.unshift({ value: uniquePropertyName, alwaysUseInPdf: true });

        data.push({ cells, scope: getScopeOfProperty(properties, uniquePropertyName) });
    }

    return { data, headers };
};

export default reduceTablePropertiesPerLabelData;
